import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Globals } from "./../globals";
import { environment } from "../../environments/environment";
import jwtDecode, { JwtPayload } from "jwt-decode";

@Injectable({ providedIn: "root" })
export class AuthService {
  public tokenKey = "prime-token";
  public clientId = "prime-apps";

  constructor(private http: HttpClient, public globals: Globals) {
    this.token = localStorage.getItem(this.tokenKey);
  }

  public token: string;

  login(username: string = "", password: string = ""): Promise<any> {
    const params = new URLSearchParams();
    params.append("username", username);
    params.append("password", password);
    params.append("grant_type", "password");
    params.append("client_id", this.clientId);
    const headers = new HttpHeaders({ "Content-type": "application/x-www-form-urlencoded; charset=utf-8" });
    const options = { headers };

    return this.http
      .post(environment.authUrl, params.toString(), options)
      .toPromise()
      .then((res) => {
        // login successful if there's a jwt token in the response
        const respToken = (res as JWT).access_token;

        if (respToken) {
          // set token property
          this.token = respToken;
          console.log('TOKEN: ' + this.token);
          const token = jwtDecode<JwtPayload>(respToken);
          console.log('JWT: ' + token);
          const date = new Date(token.exp * 1000);

          // store username and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem(this.tokenKey, respToken);
          localStorage.setItem("token_expiry", date.toString());

          // return true to indicate successful login
          return true;
        } else {
          // return false to indicate failed login
          return false;
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  public getTokenExpiryDate(): any {
    if (this.isLogged()) {
      return new Date(localStorage.getItem("token_expiry"));
    }
    return new Date(Date.now());
  }

  logout(): void {
    // clear token remove user from local storage to log user out
    localStorage.clear();
    this.token = null;
  }

  isLogged() {
    const ltoken = localStorage.getItem(this.tokenKey);
    return ltoken != null && ltoken !== "";
  }
}

export class JWT {
  // tslint:disable-next-line: variable-name
  access_token: string;
  // tslint:disable-next-line: variable-name
  token_type: string;
  // tslint:disable-next-line: variable-name
  expires_in: string;
}
